import { commonContent as commonContentUS } from '../en-us/commonContent';

export const commonContent = {
  ...commonContentUS,
  referFriendCard: {
    title: 'Refer Friends',
    text: 'Get €15 for every friend you refer once they make their first purchase.'
  }
};
